import { FOCUS_TRAP_SELECTOR } from './constants'
import handleFocusBackwards from './handleFocusBackwards'
import handleFocusForwards from './handleFocusForwards'

const FOCUSABLE_ELEMENT_SELECTORS = '[href], button:not([disabled]), [tabindex="0"]'

interface HandleArrowKey {
  current?: HTMLDivElement | null
  key: string
  isArrowKeyNavigationActivated?: boolean
}

const handleArrowKey = (
  { current, key, isArrowKeyNavigationActivated }: HandleArrowKey,
  name: string,
): void => {
  const dialogs = document.querySelectorAll(`${FOCUS_TRAP_SELECTOR}[data-modal-name=${name}]`)
  const isCurrentActiveDialog = dialogs[dialogs.length - 1] === current
  if (
    current &&
    isCurrentActiveDialog &&
    isArrowKeyNavigationActivated &&
    (key === 'ArrowDown' || key === 'ArrowUp')
  ) {
    const currentActiveElement = document.activeElement as HTMLElement
    const focusableElements = current.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS)
    const HTMLFocusableElements: HTMLElement[] = []
    focusableElements.forEach((el) => {
      if (el instanceof HTMLElement) {
        HTMLFocusableElements.push(el)
      }
    })
    const currentActiveElementIndex = HTMLFocusableElements.findIndex(
      (element) => element === currentActiveElement,
    )
    if (key === 'ArrowDown') {
      return handleFocusForwards(HTMLFocusableElements, currentActiveElementIndex)
    }
    return handleFocusBackwards(HTMLFocusableElements, currentActiveElementIndex)
  }
  return undefined
}

export default handleArrowKey
